import { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import "../../../../_metronic/assets/sass/customstyle.scss";
import OtpInput from "react-otp-input";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getDashboardKYCCard, getUserDashboard } from "../../api";
import { Downloadloader } from "../../../component/helper";
import { getProject, getProjectByCompany } from "../../projectData";
// import { UserTitle } from "../../userContext";


/**
 * BankPanCard component displays PAN, Bank, and UPI details for user dashboard.
 * Handles verification status, update actions, and navigation for each KYC type.
 */
const BankPanCard = ({ login = null }) => {
  const project = getProject();
  const company = getProjectByCompany();
  const { userId } = useParams();
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loader, setLoader] = useState(null);
  const [showBankOptions, setShowBankOptions] = useState(false);
  const [showUpiOptions, setShowUpiOptions] = useState(false);
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')



  useEffect(() => {
    if (userId && (company?.cname === 'corteva' || company?.cname === 'test')) {
      getUserDashboard({ id: userId, project_key: company?.pkey }).then((d) => setSettings(d?.data))
    } else {
      if (userId && project) {
        getUserDashboard({ id: userId, project_key: project?.pkey }).then((d) => setSettings(d?.data))
      }
    }
  }, [userId, project, company])

  useEffect(() => {
    if (settings) {
      getDashboardKYCCard(userId).then((d) => {
        setLoader(true);
        setUserData(d);
      })
    }
  }, [settings, userId]);

  const handleBankUpdate = () => {
    // Logic for handling Update functionality
    navigate(`/${redirectUrl}/addbank-detail/${userData?.iirpl_sap_code}`);
  };




  const handleUpiUpdate = () => {
    // Logic for handling Update functionality
    navigate(`/${redirectUrl}/add-upi/${userData?.iirpl_sap_code}`);
  };




  return (
    <>
      {/* <UserTitle>Bank / PAN Card</UserTitle> */}
      <div className="container mt-2 vh-100 pan_data">
        <div className="row">
          <div className="col-md-12">
            {loader ?
              <>
                {userData?.iirpl_sap_code ?
                  <div className="row">
                    {Number(settings?.kyc?.pan) === 1 && <>
                      {userData &&

                        userData?.api_pan_status === "VALID" ? (
                        <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4">
                          <div className="card_outer">
                            <div className="d-flex align-items-center">
                              <div className="icon_box">
                                <img
                                  width="28"
                                  alt="icon"
                                  src={toAbsoluteUrl("/media/images/pan-card-icon.png")}
                                />
                              </div>

                              <p className="px-2 mb-0 text-white">PAN Card</p>
                              {Number(userData?.pancards_verified) === 1 ? (
                                <>
                                  {/* <div className="bank-account-card">
                                    <i
                                      className="bi bi-three-dots-vertical text-white"
                                      onClick={() => setShowOptions(!showOptions)}
                                    />

                                    {showOptions && (
                                      <div className="options-dropdown p-3">
                                        <SupportLink user_code={userData?.iirpl_sap_code} />
                                      </div>
                                    )}
                                  </div> */}
                                </>
                              ) : (
                                <>
                                  {Number(userData.pan_verified) !== 0 && <></>
                                    // <div className="bank-account-card">
                                    //   <i
                                    //     className="bi bi-three-dots-vertical text-white"
                                    //     onClick={() => setShowOptions(!showOptions)}
                                    //   />
                                    //   {showOptions && (
                                    //     <div className="options-dropdown p-3">
                                    //       <SupportLink user_code={userData?.iirpl_sap_code} />

                                    //     </div>
                                    //     // <div className="options-dropdown ps-4 pe-4">
                                    //     //   <button onClick={() => handleUpdate()}>Update</button>
                                    //     //   {/* <button onClick={() => handleDelete()}>Delete</button> */}
                                    //     // </div>
                                    //   )}
                                    // </div>
                                  }
                                </>
                              )}
                            </div>

                            <div className="pandetail mt-11">
                              <p className="text-white">
                                {userData &&

                                  userData?.api_registered_name
                                  ? userData?.api_registered_name
                                  : ""}
                              </p>
                              <div className="pandigit display_digit">
                                <OtpInput
                                  value={
                                    userData &&

                                      userData?.api_pan
                                      ? userData.api_pan
                                      : ""
                                  }
                                  numInputs={10}
                                  renderInput={(props) => (
                                    <input
                                      {...props}
                                      style={{
                                        textAlign: "center",
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              <p className="text-white mt-3">
                                {userData &&
                                  userData?.api_type
                                  ? userData?.api_type
                                  : ""}
                              </p>
                            </div>
                            {userData?.pancards_verified === null ? (
                              <p className="text-white mb-1 status_data verify_pending ">
                                Verification Pending
                              </p>
                            ) : (
                              <>
                                {Number(userData?.pancards_verified) === 1 && (
                                  <p className="text-white mb-1 status_data verified_details ">
                                    Verified
                                  </p>
                                )}

                                {Number(userData?.pancards_verified) === 0 && (
                                  <div className="d-flex justify-content-between mt-3">
                                    <span className="text-white mb-1 status_data verify_rejected">
                                      Rejected
                                    </span>
                                    <Link to={`/${redirectUrl}/pan-card/${userData?.iirpl_sap_code}`} className="mt-1">
                                      <span style={{ background: '#5386B8' }} className="py-2 px-2 rounded text-white">
                                        <i className="bi bi-plus text-white"></i> Add Other
                                      </span>
                                    </Link>
                                  </div>
                                )}

                                {Number(userData?.pancards_verified) === 2 && (
                                  <p className="text-white mb-1 status_data verified_details bg-warning">
                                    Hold / PAN-Aadhaar not Linked
                                  </p>
                                )}
                              </>
                            )}

                          </div>
                        </div>
                      ) : (
                        <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4">
                          <div className="card_outer">
                            <div className="d-flex align-items-center">
                              <div className="icon_box">
                                <img
                                  width="20"
                                  alt="icon"
                                  src={toAbsoluteUrl("/media/images/pan-card-icon.png")}
                                />
                              </div>
                              <p className="px-2 mb-0 text-white">PAN Card</p>
                            </div>
                            <Link to={`/${redirectUrl}/pan-card/${userData?.iirpl_sap_code}`}>
                              <p className="bg-lightblue text-center text-white py-15 mb-0 mt-8 add_cards">
                                <i className="bi bi-plus text-white"></i> Add PAN Card
                              </p>
                            </Link>
                          </div>
                        </div>
                      )

                      }</>}
                    {Number(settings?.kyc?.bank) === 1 && <>
                      {userData &&
                        userData.bank_detail_id ? (
                        <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4">
                          <div className="card_outer bank-cardbg">
                            <div className="d-flex align-items-center">
                              <div className="icon_box">
                                <img
                                  width="20"
                                  alt="icon"
                                  src={toAbsoluteUrl("/media/images/bank.png")}
                                />
                              </div>
                              <p className="px-2 mb-0 text-white">Bank Account</p>
                              {Number(userData.bank_verified) === 1 ? (
                                <>
                                  <div className="bank-account-card">
                                    <i
                                      className="bi bi-three-dots-vertical text-white"
                                      onClick={() =>
                                        setShowBankOptions(!showBankOptions)
                                      }
                                    />

                                    {showBankOptions && (
                                      <>
                                        <div className="options-dropdown ps-4 pe-4">
                                          {/* <SupportLink /> */}
                                          <button onClick={() => handleBankUpdate()}>
                                            Update
                                          </button>
                                        </div>

                                      </>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {Number(userData.bank_verified) !== 0 &&
                                    <div className="bank-account-card">
                                      <i
                                        className="bi bi-three-dots-vertical text-white"
                                        onClick={() =>
                                          setShowBankOptions(!showBankOptions)
                                        }
                                      />

                                      {showBankOptions && (
                                        <>

                                          <div className="options-dropdown ps-4 pe-4">
                                            <button onClick={() => handleBankUpdate()}>
                                              Update
                                            </button>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  }
                                </>
                              )}
                            </div>
                            {/* // Display dynamic data if bank details are available */}
                            <div className="verified_bankdetails">
                              <p className="text-white">
                                Bank Name:{" "}
                                {userData?.api_bankName}
                              </p>
                              <p className="text-white">
                                Branch:{" "}
                                {userData?.api_branch}
                              </p>
                              <p className="text-white">
                                City: {userData?.api_city}
                              </p>
                              <p className="text-white">
                                Name at Bank:{" "}
                                {userData.api_nameAtBank}
                              </p>
                              <p className="text-white">
                                Reference Id:{" "}
                                {userData?.api_refId}
                              </p>
                              {/* Add additional dynamic data rendering here */}
                            </div>
                            {userData?.bank_verified === null ? (
                              <p className="text-white mb-1 status_data verify_pending">
                                Verification Pending
                              </p>
                            ) : (
                              <>
                                {Number(userData?.bank_verified) === 1 &&
                                  <p className="text-white mb-1 status_data verified_details">
                                    Verified
                                  </p>
                                }

                                {Number(userData?.bank_verified) === 0 &&

                                  <div className="d-flex justify-content-between">
                                    <span className="text-white mb-1 status_data verify_rejected">
                                      Rejected
                                    </span>

                                    <Link to={`/${redirectUrl}/addbank-detail/${userData?.iirpl_sap_code}`} className="mt-1">
                                      <span style={{ background: '#506B51' }} className=" py-2 px-2 rounded  text-white">
                                        <i className="bi bi-plus text-white"></i> Add Other
                                      </span>
                                    </Link>
                                  </div>
                                }

                                {Number(userData?.pancards_verified) === 2 && (
                                  <p className="text-white mb-1 status_data verified_details bg-warning">
                                    Hold
                                  </p>
                                )}
                              </>
                            )}

                          </div>
                        </div>
                      ) : (
                        // Display option to add bank details if bank details are null
                        <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4">
                          <div className="card_outer bank-cardbg">
                            <div className="d-flex align-items-center">
                              <div className="icon_box">
                                <img
                                  width="20"
                                  alt="icon"
                                  src={toAbsoluteUrl("/media/images/bank.png")}
                                />
                              </div>
                              <p className="px-2 mb-0 text-white">Bank Account</p>{" "}
                              {/* {userData?.BankCashfree?.original?.data.status ===
                      "ERROR" ? (
                        <p className="mt-2 text-white">Verification Pending</p>
                      ) : (
                        ""
                      )} */}
                            </div>
                            <Link to={`/${redirectUrl}/addbank-detail/${userData?.iirpl_sap_code}`}>
                              <p className="bg-lightgreen text-center text-white py-15 mb-0 mt-8 add_cards">
                                <i className="bi bi-plus text-white"></i> Add Bank
                                Account
                              </p>
                            </Link>
                          </div>
                        </div>
                      )}</>
                    }
                    {Number(settings?.kyc?.upi) === 1 && <>
                      {userData &&
                        userData.gpay_id ? (
                        <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4">
                          <div className="card_outer upi-cardbg">
                            <div className="d-flex align-items-center">
                              <div className="icon_box">
                                <img
                                  width="18"
                                  alt="icon"
                                  src={toAbsoluteUrl("/media/images/upi-icon.png")}
                                />
                              </div>
                              <p className="px-2 mb-0 text-white">UPI ID</p>
                              {Number(userData.gpays_verified) === 1 ? (
                                <>
                                  <div className="bank-account-card">
                                    <i
                                      className="bi bi-three-dots-vertical text-white"
                                      onClick={() => setShowUpiOptions(!showUpiOptions)}
                                    />

                                    {showUpiOptions && (
                                      <div className="options-dropdown ps-4 pe-4">
                                        <button onClick={() => handleUpiUpdate()}>
                                          Update
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {Number(userData.gpays_verified) !== 0 &&
                                    <div className="bank-account-card">
                                      <i
                                        className="bi bi-three-dots-vertical text-white"
                                        onClick={() => setShowUpiOptions(!showUpiOptions)}
                                      />

                                      {showUpiOptions && (
                                        <>
                                          {/* <div className="options-dropdown p-3">
                                          <SupportLink />
                                        </div> */}
                                          <div className="options-dropdown ps-4 pe-4">
                                            <button onClick={() => handleUpiUpdate()}>
                                              Update
                                            </button>
                                          </div>
                                        </>



                                      )}
                                    </div>
                                  }
                                </>
                              )}
                            </div>

                            <div className="upiid_data mt-11">
                              <p className="bg-rounded">
                                {/* {userData?.GpayCashfree?.data?.data?.nameAtBank} */}
                                {userData?.upi_id}
                              </p>
                              <p className="text-white mt-4">This UPI ID will be displayed to others when you send or receive money via UPI.</p>

                            </div>


                            {Number(userData?.gpays_verified) === 1
                              ?
                              <p className="text-white mb-1 status_data verified_details">
                                Verified
                              </p>

                              : Number(userData?.gpays_verified) === 0
                                ?

                                <div className="d-flex justify-content-between">
                                  <span className="text-white mb-1 status_data verify_rejected">
                                    Rejected
                                  </span>

                                  <Link to={`/${redirectUrl}/add-upi/${userData?.iirpl_sap_code}`} className="mt-1">
                                    <span style={{ background: '#703D59' }} className=" py-2 px-2 rounded text-white">
                                      <i className="bi bi-plus text-white"></i> Add Other
                                    </span>
                                  </Link>
                                </div>
                                :
                                <p className="text-white mb-1 status_data verify_pending">
                                  {"Verification Pending"}{" "}
                                </p>
                            }

                          </div>
                        </div>
                      ) : (
                        <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4">
                          <div className="card_outer upi-cardbg">
                            <div className="d-flex align-items-center">
                              <div className="icon_box">
                                <img
                                  width="18"
                                  alt="icon"
                                  src={toAbsoluteUrl("/media/images/upi-icon.png")}
                                />
                              </div>
                              <p className="px-2 mb-0 text-white">UPI ID</p>
                            </div>
                            <Link to={`/${redirectUrl}/add-upi/${userData?.iirpl_sap_code}`}>
                              <p className="bg-lightpurple text-center text-white py-15 mb-0 mt-8 add_cards">
                                <i className="bi bi-plus text-white"></i> Add UPI ID
                              </p>
                            </Link>
                          </div>
                        </div>
                      )}
                    </>
                    }
                  </div>
                  : <div className="alert alert-danger d-flex align-items-center p-5">
                    <i className="bi bi-exclamation-triangle fs-2hx text-danger me-4"></i>

                    <div className="d-flex flex-column">
                      <h4 className="mb-1 text-dark">User Not Found</h4>
                      <span className="">Provide detail not found on this project <span className="text-dark fs-4 text-uppercase">{userId}</span>.</span>
                    </div>
                  </div>

                }
              </>
              : <div className="d-flex"><Downloadloader /></div>
            }
          </div>
          {project?.pname !== 'greenply' && <>
            <div className="col-12 text-center">
              <p className="text-dark">Need help? Reach out to our support team</p>
              <button
                type="button"
                className="btn btn-dark mt-1 w-100"
                onClick={() => navigate(`/${redirectUrl}/support/${userData?.iirpl_sap_code}`)}
              >
                Support <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </>
          }
        </div>
      </div >
    </>
  );
};

export default BankPanCard;
